<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Product
      <i class="fa fa-fw fa-question-circle" v-tooltip data-placement="right" title="Pull product from supplier"></i>
    </div>
    <div class="panel-body">
      <div class="form-inline form-inline--better-spaced form-inline--compact-- form-inline--one-liner--">
        <div class="form-group">
          <label title="This product ID refered to is from the Supplier">Product ID</label>
          <input class="form-control" type="text" v-model="productId" :disabled="loading" title="This product ID refered to is from the Supplier" />
        </div>
        <div class="form-group">
          <label>Supplier</label>
          <select class="form-control" v-model="supplierId" :disabled="loading">
            <option :value="null">Sellect Supplier</option>
            <option v-for="(opt, key) in supplierOptions" :key="key" :value="opt.value" v-html="opt.label"></option>
          </select>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="viewPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-eye"></i> View Payload</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="applyPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-check"></i> Apply</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="clearForm" :disabled="(!formIsOk || loading) && !payload"><i class="fa fa-fw fa-times"></i> Clear</button>
        </div>
      </div>
      <div v-if="!!payload">
        <a href="#" @click.prevent="togglePayloadView">{{ showPayload ? 'Hide' : 'Show' }} Payload</a>
        <pre v-if="showPayload">{{ payload }}</pre>
      </div>
    </div><!-- .panel-body -->
  </div><!-- .panel -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Tooltip from '@/plugin/directive/tooltip'

export default {
  name: 'sync-by-product-form-component',
  data() {
    return {
      productId: null,
      supplierId: null,
      showPayload: true
    }
  },
  computed: {
    ...mapState('dropship/seller/syncProduct', {
      supplierOptions: 'supplierOptions',
      payload: 'payloadByProduct'
    }),
    ...mapGetters('dropship/seller/syncProduct', {
      isRequestingServer: 'isRequestingServer'
    }),
    formIsOk() {
      return this.productId && this.supplierId
    },
    loading() {
      return this.isRequestingServer
    }
  },
  methods: {
    togglePayloadView() {
      this.showPayload = !this.showPayload
    },
    viewPayload() {
      this.showPayload = true
      this.$store.dispatch(
        'dropship/seller/syncProduct/viewPayloadByProduct',
        {productId: this.productId, supplierId: this.supplierId}
      )
    },
    async applyPayload() {
      try {
        const response = await this.$store.dispatch(
          'dropship/seller/syncProduct/applyPayloadByProduct',
          {productId: this.productId, supplierId: this.supplierId}
        )
        if (response) {
          this.$alertify.success('Product synchronized')
        } else {
          this.$alertify.error('Product NOT synchronized')
        }
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to apply payload.  Message: ' + reason)
        }
      }
    },
    clearForm() {
      this.productId = null
      this.supplierId = null
      this.showPayload = true
      this.$store.dispatch('dropship/seller/syncProduct/clearPayloadByProduct')
    }
  },
  directives: {
    tooltip: Tooltip
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
